/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:38:36
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-02-27 11:23:57
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdCommonModule } from '../common/index';
import { MenuComponent } from './menu.component';
import { DefaultComponent } from './default/default.component';

@NgModule({
  declarations: [DefaultComponent, MenuComponent],
  imports: [AdCommonModule, CommonModule],
  exports: [MenuComponent]
})
export class MenuModule {}
